import classNames from "classnames";
import { trackNavClick } from "core/monitoring/Events";
import { FunctionComponent, SVGProps } from "react";

import { useNavigate } from "react-router-dom";

type BottomNavBarButton = {
  active?: boolean;
  navigatePath: string;
  activeIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
  inactiveIcon: FunctionComponent<SVGProps<SVGSVGElement>>;
  ariaLabel: string;
  buttonText: string;
};

export const BottomNavButton = ({ active, navigatePath, activeIcon, inactiveIcon, ariaLabel, buttonText }: BottomNavBarButton) => {
  const navigateHook = useNavigate();
  const Icon = active ? activeIcon : inactiveIcon;

  return (
    <button
      className="bottom-nav-bar-button"
      aria-label={ariaLabel}
      onClick={() => {
        trackNavClick(navigatePath);
        navigateHook(navigatePath);
      }}
    >
      <Icon className="h-6" />
      <p aria-disabled="true" className={classNames("bottom-nav-bar-text", { active: active })}>
        {buttonText}
      </p>
    </button>
  );
};
